import { Modal, Offcanvas, Tab } from "bootstrap";

export const explanationPanel = {
  _section: null,

  _sections: {
    brahma_muhurta: {
      label: "Brāhma Muhūrta",
      extendedInfo: true,
    },

    pratah_sandhya: {
      label: "Prātaḥ Sandhyopāsanam",
      extendedInfo: true,
    },
    madhyahnika: {
      label: "Madhyāhnika",
      extendedInfo: false,
    },
    sayam_sandhya: {
      label: "Sāyaṁ Sandhyopāsanam",
      extendedInfo: true,
    },
    solar_timings: {
      label: "Sūryodaya / Sūryāsta & Solar Noon",
      extendedInfo: false,
    },
    dst_adjustment: {
      label: "Daylight Saving Adjustment",
      extendedInfo: false,
    },
    polar_daynight: {
      label: "Polar Day/Night",
      extendedInfo: false,
    },
    ghati_warning: {
      label: "Deviation from Traditional Ghati",
      extendedInfo: false,
    },
  },

  extendedInfo: {
    introduction: "",
    scripture: "",
    expiation: "",
  },

  _loadingExtendedInfo: false,

  _explanationPanel: null,
  _extendedInfoModal: null,

  init() {
    const el = document.getElementById("explanationPanel");
    this._explanationPanel = new Offcanvas(el);

    const el2 = document.getElementById("extendedInfoModal");
    this._extendedInfoModal = new Modal(el2);
  },

  showContextualInformation(section) {
    if (!this._sections.hasOwnProperty(section)) {
      console.log("Unknown section " + section);
      return false;
    }
    console.log(section);

    this._section = section;
    this._explanationPanel.show();
  },

  async fetchExtendedInfo() {
    if (this._loadingExtendedInfo === true) {
      return false; // will not load
    }

    this._loadingExtendedInfo = true;
    const url = new URL(
      `/res/info/${this._section}.htm`,
      window.location.origin
    );
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const htmlText = await response.text();

    // Parse the HTML into a DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");

    this.extendedInfo = {
      introduction: doc.querySelector("#introduction")?.innerHTML || "",
      scripture: doc.querySelector("#scripture")?.innerHTML || "",
      expiation: doc.querySelector("#expiation")?.innerHTML || "",
    };

    this._loadingExtendedInfo = false;

    this._explanationPanel.hide();
    this._extendedInfoModal.show();
    Alpine.nextTick(() => {
      // 🔴 RESET TAB STATE HERE
      console.log("Reseting Tab Pointer");
      this._resetExtendedInfoTabs();
    });
  },

  get sectionHeader() {
    return this._section ? this._sections[this._section]["label"] : "";
  },

  get sectionExtendedInfo() {
    return this._section
      ? this._sections[this._section]["extendedInfo"]
      : false;
  },

  _resetExtendedInfoTabs() {
    const modalEl = document.getElementById("extendedInfoModal");
    if (!modalEl) return;

    const introBtn = modalEl.querySelector(
      'button[data-bs-target="#introduction"]'
    );

    if (!introBtn) return;

    // Dispose any existing Tab instances (IMPORTANT)
    Tab.getInstance(introBtn)?.dispose();

    // Activate fresh
    console.log("Trying to switch to tab pane 1");
    Tab.getOrCreateInstance(introBtn).show();
  },
};
